import React from "react";

const Tipography = () => {
  return (
    <div>
      <div class="bg-[--white-05] max-w-fit font-bold py-2 px-4 rounded-full text-[--information]">
        Headings
      </div>
      <div className="py-6 flex gap-4 border-solid border-1b border-[--white-10]">
        <p className="w-1/5">Title - H1</p>
        <h1 className="w-4/5">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua
        </h1>
      </div>
      <div className="py-6 flex gap-4 border-solid border-1b border-[--white-10]">
        <p className="w-1/5">Headline - H2</p>
        <h2 className="w-4/5">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua
        </h2>
      </div>
      <div className="py-6 flex gap-4 border-solid border-1b border-[--white-10]">
        <p className="w-1/5">Headline - H3</p>
        <h3 className="w-4/5">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua
        </h3>
      </div>
      <div className="py-6 flex gap-4 border-solid border-1b border-[--white-10]">
        <p className="w-1/5">Headline - H4</p>
        <h4 className="w-4/5">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua
        </h4>
      </div>
      <div className="py-6 flex gap-4 border-solid border-1b border-[--white-10]">
        <p className="w-1/5">Headline - H5</p>
        <h5 className="w-4/5">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua
        </h5>
      </div>
      <div className="py-6 flex gap-4 border-solid border-1b border-[--white-10]">
        <p className="w-1/5">Headline - H6</p>
        <h6 className="w-4/5">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua
        </h6>
      </div>
      <div class="bg-[--white-05] max-w-fit font-bold py-2 px-4 rounded-full text-[--information] mt-4">
        Subtitles
      </div>
      <div className="py-6 flex gap-4 border-solid border-1b border-[--white-10]">
        <p className="w-1/5">Subtitle - S1</p>
        <p className="w-4/5 s1">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua
        </p>
      </div>
      <div className="py-6 flex gap-4 border-solid border-1b border-[--white-10]">
        <p className="w-1/5">Subtitle - S2</p>
        <p className="w-4/5 s2">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua
        </p>
      </div>
      <div className="py-6 flex gap-4 border-solid border-1b border-[--white-10]">
        <p className="w-1/5">Subtitle - S3</p>
        <p className="w-4/5 s3">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua
        </p>
      </div>
      <div class="bg-[--white-05] max-w-fit font-bold py-2 px-4 rounded-full text-[--information] mt-4">
        Paragraphs
      </div>
      <div className="py-6 flex gap-4 border-solid border-1b border-[--white-10]">
        <p className="w-1/5">Paragraph - P1</p>
        <p className="w-4/5 p1">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua
        </p>
      </div>
      <div className="py-6 flex gap-4 border-solid border-1b border-[--white-10]">
        <p className="w-1/5">Paragraph - P2</p>
        <p className="w-4/5 p2">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua
        </p>
      </div>
      <div className="py-6 flex gap-4 border-solid border-1b border-[--white-10]">
        <p className="w-1/5">Paragraph - P3</p>
        <p className="w-4/5 p3">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua
        </p>
      </div>
      <div className="py-6 flex gap-4 border-solid border-1b border-[--white-10]">
        <p className="w-1/5">Paragraph - P4</p>
        <p className="w-4/5 p4">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua
        </p>
      </div>
      <div className="py-6 flex gap-4 border-solid border-1b border-[--white-10]">
        <p className="w-1/5">Paragraph - P5</p>
        <p className="w-4/5 p5">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua
        </p>
      </div>
      <div className="py-6 flex gap-4 border-solid border-1b border-[--white-10]">
        <p className="w-1/5">Paragraph - P6</p>
        <p className="w-4/5 p6">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua
        </p>
      </div>
    </div>
  );
};

export default Tipography;
